import {TOGGLE_RIGHT_SIDEBAR} from './types';

export function toggleRightSidebarOpen() {
  return dispatch => {
    return dispatch({
      type: TOGGLE_RIGHT_SIDEBAR
    })
  }
}